import { useFormContext, useFormState, Controller, useFieldArray } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import GoogleCategoriesForm from '@features/GoogleCategoriesForm';
import { Input } from '@components/Input';
import FieldWithActions, { rowActions } from '@components/FieldWithActions';
import { useTranslation } from '@hooks';
import { MAX_SERVICES } from '@constants/companies';

const Form = styled('div')({
    maxWidth: 698,
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gap: '16px',
    '@media (max-width: 1024px)': {
        maxWidth: 'none',
        gridTemplateColumns: '100%',
    },
});

const CategoriesAndServices = () => {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const { isSubmitting } = useFormState({ control });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'services',
    });

    return (
        <Form>
            <GoogleCategoriesForm fieldsName="secondaryCategories" />
            <div style={{ display: 'flex', gap: '24px', flexFlow: 'column' }}>
                {fields.map((field, index) => (
                    <FieldWithActions
                        key={field.id}
                        actions={rowActions({
                            index,
                            count: fields.length,
                            onAdd: () => append({ name: '' }),
                            onDelete: () => remove(index),
                            canAdd: fields.length < MAX_SERVICES,
                            disabled: isSubmitting,
                            t,
                        })}
                    >
                        <Controller
                            control={control}
                            name={`services.${index}.name`}
                            render={({ field, ref }) => (
                                <Input
                                    ref={ref}
                                    inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                    label={`${t('common.service')} ${index + 1}`}
                                />
                            )}
                        />
                    </FieldWithActions>
                ))}
            </div>
        </Form>
    );
};

export default CategoriesAndServices;
